import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BoletoCard } from "./components/boletoChange";
import { PaymentSection } from "./components/paymentSection";
import ResumoSection from "./components/paymentResumo";
import { useTicket } from "../../../hooks/useTicket";

export function ContaConsumo() {

  const {
    boleto,
    getTicket,
    payTicketFitbank,
    payTicketWithCreditCard,
    listCards,
    createCard,
    cardsData
  } = useTicket();


useEffect(() => {
  const fetchCards = async () => {
    if (!cardsData) {
      await listCards();
    }
  };
  fetchCards();
}, []);

  const [modo, setModo] = useState("saldo"); // saldo | cartao
  const [parcelas, setParcelas] = useState(12);
  const [showToast, setShowToast] = useState(false);

  const JUROS_MENSAL = 0.035;

  const parcelaPrice = (principal, n, i) => {
    if (n === 1) {
      const total = principal * (1 + i);
      return total;
    }

    const f = Math.pow(1 + i, n);
    const res = principal * ((i * f) / (f - 1));

    if (isNaN(res)) return "-";
    return res;
  };


  const calcularParcela = (valor, n) => parcelaPrice(valor, n, JUROS_MENSAL);

  return (
    <div className="transferencia-ted">
      <div className="transferencia-ted-container col-md-10">
        {/* HEADER */}
        <div className="header">
          <div className="col-xl-12">
            <label>
              <Link to="/pagina-principal">
                Pagina inicial
                <MdKeyboardArrowRight size={20} />
              </Link>
              Conta de Consumo
            </label>
            <p>Pagar Conta de Consumo</p>
          </div>
        </div>

        {/* BODY */}
        <div className="body">
          <main className="max-w-3xl mx-auto px-4 py-6 space-y-6">
            <BoletoCard
              boleto={boleto}
              getTicket={getTicket}
            />
            <PaymentSection setShowToast={setShowToast} setModo={setModo} setParcelas={setParcelas} modo={modo} parcelas={parcelas} payTicket={payTicketFitbank} payTicketWithCreditCard={payTicketWithCreditCard} boleto={boleto} listCards={listCards} createCard={createCard} cardsData={cardsData} />
            <ResumoSection parcelas={parcelas} modo={modo} valor={boleto.totalValue} calcularParcela={calcularParcela} conta={boleto.beneficiaryName} />

          </main>

          {/* TOAST */}
          {showToast && (
            <div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
